import Vue from 'vue'
import Vuex from 'vuex'

import config from '@/config'
import router from '@/router'

import { timestampToReadable } from '@/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogged: !!localStorage.getItem('token'),
    isAdmin: (!!localStorage.getItem('isAdmin') && localStorage.getItem('isAdmin') == "true"),
    queryRunning: false,
    queryStart: new Date(),
    queryLastParam: {
      from: null,
      to: null,
      deviceFilter: []
    },
    queryLastResult: {
      columns: [],
      rows: []
    },
    queryLastResultDevices: [],
    queryLastResultMarkers: [],
    queryLastResultPaths: [],
    userDevices: [],
    currentGraphDeviceID: ""
  },

  mutations: {
    LOGIN_USER (state) {
      state.isLogged = true
      state.isAdmin = false
      localStorage.setItem('isAdmin', "false")
    },

    LOGIN_ADMIN (state) {
      state.isLogged = true
      state.isAdmin = true
      localStorage.setItem('isAdmin', "true")
    },
    
    LOGOUT_USER (state) {
      state.isLogged = false
      state.isAdmin = false
      localStorage.setItem('isAdmin', "false")
    },

    SET_USER_DEVICES (state, devices) {
      state.userDevices = devices
    },

    SET_CURRENT_GRAPH_DEVICE(state, deviceID) {
      state.currentGraphDeviceID = deviceID
    },

    UPDATE_QUERY_PARAMS (state, query) {
      state.queryLastParam = query
    },

    UPDATE_QUERY_RESULT (state, queryResult) {
      let elapsed = ((new Date()) - state.queryStart)

      console.log("server took " + elapsed + "ms to respond")

      state.queryLastResult = queryResult

      /* find devices in query response */
      console.log("computing devices")

      let contains = (a, elem) => a.indexOf(elem) > -1

      let devices = []
      let endRecords = {}
      for (let idx in state.queryLastResult.rows) {
        const deviceID = state.queryLastResult.rows[idx][2]

        if (!contains(devices, deviceID)) {
          devices.push(deviceID)
          endRecords[deviceID] = {
            first: idx,
            last: idx
          }
        } else {
          endRecords[deviceID].first = idx
        }
      }

      /* update current graph device ID if not set, setting it to first device in list (device of last record) */
      if (state.currentGraphDeviceID == "") {
        state.currentGraphDeviceID = devices[0]
      }

      /* compute path markers array */
      console.log("computing path markers")

      let pathsMarkers = []
      devices.forEach((device) => {
        let buildMarker = (record, iconName) => {
          let text = ''
          
          if (iconName == 'path-start') {
            text += '<i>Inizio percorso [query specificata]</i><br>'
          } else {
            text += '<i>Fine percorso [query specificata]</i><br>'
          }
          text += '<b>' + record[3] + '</b><br>'
          text += '<span class="device-id">' + record[2].substr(0, 12) + '</span><br>'
          text += record[4] + ', ' + record[5] + '<br>'
          text += timestampToReadable(record[1]) + '<br>'

          return {
            id: iconName + record[2],
            device_label: record[3],
            position: {
              lat: record[4],
              lon: record[5]
            },
            tooltip: text,
            icon: iconName
          }
        }

        const firstRecord = state.queryLastResult.rows[endRecords[device].first]
        const lastRecord = state.queryLastResult.rows[endRecords[device].last]

        pathsMarkers.push(buildMarker(firstRecord, 'path-start'))
        pathsMarkers.push(buildMarker(lastRecord, 'path-stop'))
      })

      /* compute path for each device */
      console.log("computing paths")

      const paths = devices.map((device) => {
        let path = []

        state.queryLastResult.rows.forEach((row) => {
          if (row[2] == device) {
            path.push([row[4], row[5]])
          }
        })

        return path
      })

      state.queryLastResultDevices = devices
      state.queryLastResultPaths = paths
      state.queryLastResultPathsMarkers = pathsMarkers
      state.queryRunning = false
    },

    SET_QUERY_RUNNING (state, running) {
      state.queryRunning = running
      state.queryStart = new Date()
    }
  },

  actions: {
    RUN_QUERY(context, data) {
      context.commit('SET_QUERY_RUNNING', true)

      const http = data.http
      const query = data.query

      context.commit('UPDATE_QUERY_PARAMS', query)

      let request = {
        from: query.from,
        to: query.to
      }

      if (query.deviceFilter.length > 0)
        request.devices = query.deviceFilter.join(',')

      console.log("running query: ", request)

      http.get(config.API_URL + '/query', {
        params: request,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        (response) => {
          if (response.body == null) {
            context.commit('UPDATE_QUERY_RESULT', [])
          } else {
            context.commit('UPDATE_QUERY_RESULT', response.body)
          }
        }, (err) => {
          // TODO check what to do here
          console.log(err)
          context.commit('UPDATE_QUERY_RESULT', [])
          context.commit('LOGOUT_USER')
          localStorage.removeItem('token')
          router.push('/login')
        }
      )
    },

    REFRESH_QUERY (context, http) {
      context.dispatch('RUN_QUERY', {
        http: http,
        query: context.state.queryLastParam
      })
    },

    REFRESH_USER_DEVICES (context, http) {
      if (context.state.isLogged == false) {
        // can't refresh the user device list if we are not logged in
        return
      }

      http.get(config.API_URL + '/devices', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        (response) => {
          if (response.body != null) {
            context.commit('SET_USER_DEVICES', response.body)
          }
        }, (err) => {
          console.log(err)
          context.commit('LOGOUT_USER')
          localStorage.removeItem('token')
          router.push('/login')
        }
      )
    }
  }
})
